<mida-auth-wrapper>
  @if (!isOtpModalOpen()) {
    <p class="header">Welcome back</p>
    <p class="sub-header">Please enter your details to log into your account</p>
    <form [formGroup]="loginForm" class="mida-form" (ngSubmit)="onSubmit($event)" autocomplete="off">
      <div class="mida-form-field">
        <label for="email">Email address</label>
        <div class="mida-form">
          <img src="assets/icons/mail.svg" alt="lock icon" />
          <input type="text" formControlName="email" id="email" placeholder="name@example.com" name="ixdhdihdxkhdkhie" autocomplete="crack" />
        </div>
        <!-- @if (loginForm.controls.email; as email) {
          @if (email.dirty && email.hasError('required')) {
            <span class="error-message">Email is required</span>
          }
          @if (email.dirty && email.hasError('email')) {
            <span class="error-message">Please enter a valid email address</span>
          }
        } -->
      </div>
      <div class="mida-form-field">
        <label for="password">Password</label>
        <div class="mida-form">
          <img src="assets/icons/lock.svg" alt="lock icon" />
          <input type="password" formControlName="password" id="password" placeholder=" password" #passwordRef name="kdxkhupihfheohwiwabhfdjo" autocomplete="current-password" />
        </div>
        <!-- @if (loginForm.controls.password; as password) {
          @if (password.dirty && password.hasError('required')) {
            <span class="error-message">Password is required</span>
          }
        } -->
        <p class="show-password-button" role="button" (click)="togglePasswordState()">
          <img [src]="'assets/icons/eyes-' + passwordState() + '.svg'" alt="eyes open icon" />
        </p>
        <a routerLink="/forgot-password">Forgot your password?</a>
      </div>
      <button class="mida-button">
        @if (isLoaderShowing()) {
          <img src="assets/images/loader.svg" alt="loader" />
          <span>Log in...</span>
        } @else {
          <span>Log in</span>
        }
      </button>
    </form>
  } @else {
    <div class="otp-container">
      <p class="header otp-header">Verification code</p>
      <p class="sub-header otp-sub-header">Please enter the 6-digit verification code sent to your email.</p>

      <div class="otp-inputs">
        @for (digit of otpDigits; track $index) {
          <input
            type="text"
            inputmode="numeric"
            maxlength="1"
            [id]="'otp-input-' + $index"
            [value]="otpDigits[$index]"
            (input)="onOtpInput($event, $index)"
            (keydown)="onOtpKeydown($event, $index)"
            class="otp-box"
          />
        }
      </div>

      <button class="mida-button" (click)="verifyOtp()" [disabled]="isOtpVerifying() || otpDigits.join('').length < 6">
        @if (isOtpVerifying()) {
          <img src="assets/images/loader.svg" alt="loader" />
          <span>Verifying...</span>
        } @else {
          <span>Verify Code</span>
        }
      </button>

      <div class="resend-container">
        <span class="resend-text">Didn't receive the code?</span>
        <a href="#" (click)="resendOtp($event)" [class.disabled]="isResendingOtp()">Resend</a>
      </div>
    </div>
  }
</mida-auth-wrapper>
